// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__q1UQ_","wrapper":"Divider_wrapper__mGILZ"};